import { formatBooleanForAPI, formatNumberForAPI } from '../utils/apiUtils';

export const convertDataSettings = (settings) => {
  return {
    ...settings,
    disconnect_after_inactivity: !!settings.disconnect_after_inactivity,
    record_last_trace_in_live: !!settings.record_last_trace_in_live,
  };
};

export const convertAlarm = (alarm) => {
  return {
    ...alarm,
    enabled: formatBooleanForAPI(alarm.enabled),
    mode: formatNumberForAPI(alarm.mode),
    start: formatBooleanForAPI(alarm.start),
    stop: formatBooleanForAPI(alarm.stop),
  };
};

export const convertAlarmGroup = (group) => {
  return {
    ...group,
    snapshot_id: formatNumberForAPI(group.snapshot_id),
    alarm_id: formatNumberForAPI(group.alarm_id),
  };
};

export const convertPermissionSettings = (settings) => {
  return {
    ...settings,
    snapshot_compartmentalization: formatBooleanForAPI(
      settings.snapshot_compartmentalization
    ),
  };
};

export const convertAlarmSettings = (settings) => {
  return {
    ...settings,
    id: formatNumberForAPI(settings.id),
    ignore_interval: formatNumberForAPI(settings.ignore_interval),
    raising_count: formatNumberForAPI(settings.raising_count),
    ignore_interval_unit: formatNumberForAPI(settings.ignore_interval_unit),
    email_port: formatNumberForAPI(settings.email_port),
    alarm_email: formatBooleanForAPI(settings.alarm_email),
    snmp_port: formatNumberForAPI(settings.snmp_port),
    alarm_snmp: formatBooleanForAPI(settings.alarm_snmp),
    time_warning_email: formatBooleanForAPI(settings.time_warning_email),
    time_warning_snmp: formatBooleanForAPI(settings.time_warning_snmp),
    email_recipient: settings.email_recipient,
    alarm_audio: formatBooleanForAPI(settings.alarm_audio),
  };
};

export const convertAnalyzer = (analyzer) => {
  const { snapshots, modules, ...analyzerNoNormalizedArrays } = analyzer;
  return {
    ...analyzerNoNormalizedArrays,
    active_snapshot: formatNumberForAPI(analyzer.active_snapshot),
    type: formatNumberForAPI(analyzer.type),
    coord_system: formatNumberForAPI(analyzer.coord_system),
    number_of_ports: formatNumberForAPI(analyzer.number_of_ports),
    status: formatBooleanForAPI(analyzer.status),
    mode: formatNumberForAPI(analyzer.mode),
    port: formatNumberForAPI(analyzer.port),
    enabled: formatBooleanForAPI(analyzer.enabled),
    snapshots: undefined,
  };
};

export const convertUser = (user) => {
  return {
    ...user,
    id: formatNumberForAPI(user.id),
    role: formatNumberForAPI(user.role),
  };
};

export const convertSnapshot = (snapshot) => {
  const { monitors, masks, ...snapshotNoNormalizedArrays } = snapshot;
  return {
    ...snapshotNoNormalizedArrays,
    port: formatNumberForAPI(snapshot.port),
    switch_port: formatNumberForAPI(snapshot.switch_port),
    reference: formatNumberForAPI(snapshot.reference),
    scale: formatNumberForAPI(snapshot.scale),
    preamp: formatNumberForAPI(snapshot.preamp),
    lo_mode: formatNumberForAPI(snapshot.lo_mode),
    inverted: formatBooleanForAPI(snapshot.inverted),
    baseline_enabled: formatBooleanForAPI(snapshot.baseline_enabled),
    minmax_enabled: formatNumberForAPI(snapshot.minmax_enabled),
    sweep_mode: formatNumberForAPI(snapshot.sweep_mode),
    detection_mode: formatNumberForAPI(snapshot.detection_mode),
    average_amount: formatNumberForAPI(snapshot.average_amount),
    satellite_id: formatNumberForAPI(snapshot.satellite_id),
    analyzer_id: formatNumberForAPI(snapshot.analyzer_id),
    enabled: formatBooleanForAPI(snapshot.enabled),
    temporarily_disabled: formatBooleanForAPI(snapshot.temporarily_disabled),
    needs_validated: formatBooleanForAPI(snapshot.needs_validated),
    recording_locked: formatBooleanForAPI(snapshot.recording_locked),
  };
};

export const convertSnapshotHistorySettings = (settings) => {
  return {
    ...settings,
    continuous_mode: formatBooleanForAPI(settings.continuous_mode),
    interval_mode: formatBooleanForAPI(settings.interval_mode),
    interference_mode: formatBooleanForAPI(settings.interference_mode),
    record_interval: formatNumberForAPI(settings.record_interval),
    snapshot_id: formatNumberForAPI(settings.snapshot_id),
    polling_continuous_mode: formatBooleanForAPI(
      settings.polling_continuous_mode
    ),
    polling_interference_mode: formatBooleanForAPI(
      settings.polling_interference_mode
    ),
    polling_record_timer_enabled: formatBooleanForAPI(
      settings.polling_record_timer_enabled
    ),
    polling_record_timer_value: formatNumberForAPI(
      settings.polling_record_timer_value
    ),
  };
};

export const convertMarker = (marker) => {
  return {
    ...marker,
    index: formatNumberForAPI(marker.index),
    x_pos: formatNumberForAPI(marker.x_pos),
    snapshot_id: formatNumberForAPI(marker.snapshot_id),
  };
};

export const convertMarkerDelta = (markerDelta) => {
  return {
    ...markerDelta,
    snapshot_id: formatNumberForAPI(markerDelta.snapshot_id),
    marker1_index: formatNumberForAPI(markerDelta.marker1_index),
    marker2_index: formatNumberForAPI(markerDelta.marker2_index),
    upperbound: formatNumberForAPI(markerDelta.upperbound),
    lowerbound: formatNumberForAPI(markerDelta.lowerbound),
  };
};

export const convertSnapshotIdArray = (array) => {
  return array.map((id) => Number(id));
};

export const convertSwitch = (item) => {
  return {
    ...item,
    port: formatNumberForAPI(item.port),
    type: formatNumberForAPI(item.type),
    enabled: formatBooleanForAPI(item.enabled),
  };
};

export const convertWall = (wall) => {
  const { windows, ...wallNoNormalizedArrays } = wall;
  return {
    ...wallNoNormalizedArrays,
    rows: formatNumberForAPI(wall.rows),
    columns: formatNumberForAPI(wall.columns),
    user_id: formatNumberForAPI(wall.user_id),
  };
};

export const convertWeatherWall = (wall) => {
  const { weatherWindows, ...wallNoNormalizedArrays } = wall;
  return {
    ...wallNoNormalizedArrays,
    rows: formatNumberForAPI(wall.rows),
    columns: formatNumberForAPI(wall.columns),
    user_id: formatNumberForAPI(wall.user_id),
  };
};

export const convertWindow = (window) => {
  return {
    ...window,
    pos_x: formatNumberForAPI(window.pos_x),
    pos_y: formatNumberForAPI(window.pos_y),
    size_x: formatNumberForAPI(window.size_x),
    size_y: formatNumberForAPI(window.size_y),
    show_settings: formatBooleanForAPI(window.show_settings),
    format: formatNumberForAPI(window.format),
    wall_id: formatNumberForAPI(window.wall_id),
    analyzer_id: formatNumberForAPI(window.analyzer_id),
    snapshot_id: formatNumberForAPI(window.snapshot_id),
  };
};
export const convertWeatherWindow = (window) => {
  return {
    ...window,
    pos_x: formatNumberForAPI(window.pos_x),
    pos_y: formatNumberForAPI(window.pos_y),
    weather_wall_id: formatNumberForAPI(window.weather_wall_id),
    location_id: formatNumberForAPI(window.location_id),
  };
};

export const convertWeatherAlert = (alert) => {
  return { ...alert, enabled: formatBooleanForAPI(alert.enabled) };
};
